<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <form novalidate>
        <div class="rightSidePanel active">

            <header class="panel-header">
                <div class="viewDemo title-and-video">
                    <h2>{{this.panelHeading}}</h2>
                </div>            
                <div class="panel-left-btn">
                    <button type="button" class="btn eod-btn-outline-warning mr-2" 
                        *ngIf="this.inputModel && this.inputModel.isEditMode" (click)="fnShowGradeLoggingPanel(inputModel.gradeId)">
                        {{ "log" | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-primary mr-2" 
                        [ngClass]="{'disabled':  disableSaveButton || !(this.gradeForm && this.gradeForm.form && this.gradeForm.form.dirty) }" 
                        (click)="fnSubmitGrade()"> 
                        {{ 'save_text' | translate }}
                    </button>
                    <button type="button" class="btn eod-btn-outline-warning" 
                        (click)="fnClosePanel()" [ngClass]="{disabled: disableSaveButton}">
                        {{ "close" | translate }}
                    </button>
                </div>
            </header>
            <div>
                <dynamic-form [model]="gradeFormModel" [fields]="gradeFormFields"> </dynamic-form>
            </div>
        </div>
    </form>
</div>

<!----------------------Side Panels--------------------------->

<app-alert-panel *ngIf="showDeactivateConfirmationAlert" [data]="deactivateConfirmationAlertModel"
    (callbackEvent)="fnDeactivateAlertPanelReceiver($event)"></app-alert-panel>